import angular from "angular";

angular
	.module('app')
	.component('carHistoryPage', {
		template: require('./car-history-page.html'),
        controller: ['$http', 'moment', controller],
        bindings: {
		    categories: '<',
            car: '<',
        }
    });
    
function controller($http, moment) {
 
	let $ctrl = this;
	
	$ctrl.$onInit = function () {
	    $ctrl.nowDate = moment().format("D.M.Y");
    };
}